/* eslint semi:0 */
import { queryString } from '../../jsCore/utils/window'
import { TV_SCHEDULE_ACTION_TYPES } from './tvScheduleActions'
import { addDaysToDate, toIsoStringDate } from '../../jsCore/utils/date'
import tvScheduleEmptyDay from './tvScheduleEmptyDay' //should use default empty schedule from server - TBD by Eddy, then will change

const TV_SCHEDULE_DAYS_RANGE = 15

function getPossiblyOverridenDate() {
  const { tvScheduleDate } = queryString
  return tvScheduleDate ? new Date(tvScheduleDate) : new Date()
}

function getDefaultState() {
  return {
    channels: [],
    channelNames: [],
    currentChannel: {},
    IS_INITIALIZED: false,
    IS_LOADING: true,
    currentChannelName: '',
    get scheduleDate() {
      return getPossiblyOverridenDate()
    },
    get minDate() {
      return addDaysToDate(new Date(), -2 * TV_SCHEDULE_DAYS_RANGE)
    },
    get maxDate() {
      return addDaysToDate(new Date(), TV_SCHEDULE_DAYS_RANGE)
    },
  }
}

function setState(state, newState) {
  return { ...state, ...newState }
}

function sortScheduleDays(dayA, dayB) {
  return new Date(dayA.date) - new Date(dayB.date)
}

function sortChannelSchedule(channelData) {
  return channelData.schedule.sort(sortScheduleDays)
}

function handleNonExistingScheduleData(state) {
  const newState = mergeScheduleData(
    state,
    fillDataWithDate(tvScheduleEmptyDay, state.scheduleDate)
  )
  return transformTvChannelsData(newState)
}

function fillDataWithDate(data, scheduleDate) {
  data.channels.forEach(channel => (channel.schedule[0].date = toIsoStringDate(scheduleDate)))
  return data
}

function mergeScheduleData(state, scheduleData) {
  const channels = scheduleData.channels.reduce(reduceChannelsData, state.channels)
  channels.forEach(sortChannelSchedule)
  return { ...state, ...scheduleData, channels, IS_INITIALIZED: true, IS_LOADING: false }
}

function reduceChannelsData(accumChannelsData, newChannelData) {
  const { channel: newChannel, schedule: newSchedule } = newChannelData
  const existingChannelData = accumChannelsData.find(
    ({ channel }) => channel.name === newChannel.name
  )
  const dateExists = existingChannelData
    ? existingChannelData.schedule.some(dayShows => dayShows.date === newSchedule[0].date)
    : false
  !dateExists && !existingChannelData && accumChannelsData.push(newChannelData)
  !dateExists && existingChannelData && existingChannelData.schedule.push(newSchedule[0])
  return accumChannelsData
}

function reduceChannelNames(channelNames, { channel }) {
  return [...channelNames, channel.name]
}

export function transformTvChannelsData(state) {
  const channelNames =
    state.channelNames && state.channelNames.length
      ? state.channelNames
      : state.channels.reduce(reduceChannelNames, [])
  return {
    ...state,
    channelNames,
    currentChannelName: state.currentChannel.name,
  }
}

export default function tvChannelSelectionReducer(state = getDefaultState(), action) {
  if (TV_SCHEDULE_ACTION_TYPES) {
    switch (action.type) {
      case TV_SCHEDULE_ACTION_TYPES.FETCH.SUCCESS:
        return mergeScheduleData(state, action.state)
      case TV_SCHEDULE_ACTION_TYPES.FETCH.FAIL:
        return handleNonExistingScheduleData(state)
      case TV_SCHEDULE_ACTION_TYPES.CHANGE_SELECTED_CHANNEL_NAME:
      case TV_SCHEDULE_ACTION_TYPES.CHANGE_TV_SCHEDULE_DATE:
      case TV_SCHEDULE_ACTION_TYPES.LOADING_DATA:
        return setState(state, action.state)
      default:
        return state
    }
  }
  return setState(state, { IS_ENTRY_POINT_MISSING: true })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/tv_channel_selection/tvChannelSelectionReducer.js